import { ValidationErrorData } from '../typings/common';
import { KeywordsEditorBodyView } from '../typings/keywordsEditorData';
import { MinusPhrasesLibraryItem, MinusPhrasesShortLibraryItem } from '../typings/minusPhraseLibrary';
import { MinusPhrasesEditorTabs } from '../typings/minusPhrases';

export const OPEN_MINUS_PHRASES_EDITOR = 'OPEN_MINUS_PHRASES_EDITOR';
export type OPEN_EDITOR_MINUS_PHRASES = typeof OPEN_MINUS_PHRASES_EDITOR;

export interface OpenMinusPhrasesEditor {
    type: OPEN_EDITOR_MINUS_PHRASES;
    editorId: string;
    minusPhrases: string[];
    selectedLibraryList?: MinusPhrasesShortLibraryItem[];
    selectedTab?: MinusPhrasesEditorTabs;
}

export function openMinusPhrasesEditor(
    editorId: string,
    minusPhrases: string[],
    selectedLibraryList?: MinusPhrasesShortLibraryItem[],
    selectedTab?: MinusPhrasesEditorTabs
): OpenMinusPhrasesEditor {
    return {
        type: OPEN_MINUS_PHRASES_EDITOR,
        editorId,
        minusPhrases,
        selectedLibraryList,
        selectedTab
    };
}

export const CLOSE_MINUS_PHRASES_EDITOR = 'CLOSE_MINUS_PHRASES_EDITOR';
export type CLOSE_EDITOR_MINUS_PHRASES = typeof CLOSE_MINUS_PHRASES_EDITOR;

export interface CloseMinusPhrasesEditor {
    type: CLOSE_EDITOR_MINUS_PHRASES;
    editorId: string;
}

export function closeMinusPhrasesEditor(editorId: string): CloseMinusPhrasesEditor {
    return {
        type: CLOSE_MINUS_PHRASES_EDITOR,
        editorId
    };
}

export const OPEN_MODAL_EDIT_ADD_LIBRARY_LIST = 'OPEN_MODAL_EDIT_ADD_LIBRARY_LIST';
export type OPEN_MODAL_EDIT_ADD_LIBRARY_LIST = typeof OPEN_MODAL_EDIT_ADD_LIBRARY_LIST;

export interface OpenModalEditAddLibraryListAction {
    type: OPEN_MODAL_EDIT_ADD_LIBRARY_LIST;
    editorId: string;
}

export function openModalAddLibraryListEdit(editorId: string): OpenModalEditAddLibraryListAction {
    return {
        type: OPEN_MODAL_EDIT_ADD_LIBRARY_LIST,
        editorId
    };
}

export const CHANGE_MINUS_PHRASES_EDITOR = 'CHANGE_MINUS_PHRASES_EDITOR';
export type CHANGE_MINUS_PHRASES_EDITOR = typeof CHANGE_MINUS_PHRASES_EDITOR;

export interface ChangeMinusPhrasesEditor {
    type: CHANGE_MINUS_PHRASES_EDITOR;
    editorId: string;
    minusKeywords: string[];
}

export function changeMinusPhrasesEditor(editorId: string, minusKeywords: string[]): ChangeMinusPhrasesEditor {
    return {
        type: CHANGE_MINUS_PHRASES_EDITOR,
        editorId,
        minusKeywords
    };
}

export const CLEAR_ERRORS_MINUS_PHRASES_EDITOR = 'CLEAR_ERRORS_MINUS_PHRASES_EDITOR';
export type CLEAR_ERRORS_MINUS_PHRASES_EDITOR = typeof CLEAR_ERRORS_MINUS_PHRASES_EDITOR;

export interface ClearErrorsMinusPhrasesEditor {
    type: CLEAR_ERRORS_MINUS_PHRASES_EDITOR;
    editorId: string;
}

export function clearErrorsMinusPhrasesEditor(editorId: string): ClearErrorsMinusPhrasesEditor {
    return {
        type: CLEAR_ERRORS_MINUS_PHRASES_EDITOR,
        editorId
    };
}

export const TOGGLE_EDIT_LIBRARY_LIST = 'TOGGLE_EDIT_LIBRARY_LIST';
export type TOGGLE_EDIT_LIBRARY_LIST = typeof TOGGLE_EDIT_LIBRARY_LIST;

export interface ToggleEditLibraryListAction {
    type: TOGGLE_EDIT_LIBRARY_LIST;
    editorId: string;
    itemId: string;
}

export function toggleLibraryListEdit(editorId: string, itemId: string): ToggleEditLibraryListAction {
    return {
        type: TOGGLE_EDIT_LIBRARY_LIST,
        editorId,
        itemId
    };
}

export const CLOSE_MODAL_ADD_LIBRARY_LIST = 'CLOSE_MODAL_GROUP_ADD_LIBRARY_LIST';
export type CLOSE_MODAL_ADD_LIBRARY_LIST = typeof CLOSE_MODAL_ADD_LIBRARY_LIST;

export interface CloseModalAddLibraryListAction {
    type: CLOSE_MODAL_ADD_LIBRARY_LIST;
    editorId: string;
}

export function closeModalAddLibraryList(editorId: string): CloseModalAddLibraryListAction {
    return {
        type: CLOSE_MODAL_ADD_LIBRARY_LIST,
        editorId
    };
}

export const CHANGE_LIBRARY_LIST_EDITOR_DATA = 'CHANGE_LIBRARY_LIST_EDITOR_DATA';
export type CHANGE_LIBRARY_LIST_EDITOR_DATA = typeof CHANGE_LIBRARY_LIST_EDITOR_DATA;

export interface ChangeLibraryListEditorDataAction {
    type: CHANGE_LIBRARY_LIST_EDITOR_DATA;
    title: string;
    minusPhrases: string;
    editorId: string;
}

export function changeLibraryListEditorData(
    editorId: string,
    title: string,
    minusPhrases: string
): ChangeLibraryListEditorDataAction {
    return {
        type: CHANGE_LIBRARY_LIST_EDITOR_DATA,
        title,
        editorId,
        minusPhrases
    };
}

export const ACCEPT_LIBRARY_LIST_EDITOR_DATA = 'ACCEPT_LIBRARY_LIST_EDITOR_DATA';
export type ACCEPT_LIBRARY_LIST_EDITOR_DATA = typeof ACCEPT_LIBRARY_LIST_EDITOR_DATA;

export interface AcceptLibraryListEditorDataAction {
    type: ACCEPT_LIBRARY_LIST_EDITOR_DATA;
    editorId: string;
}

export function acceptLibraryListEditorData(editorId: string): AcceptLibraryListEditorDataAction {
    return {
        type: ACCEPT_LIBRARY_LIST_EDITOR_DATA,
        editorId
    };
}

export const FETCH_LIBRARY_LISTS_FOR_EDIT = 'FETCH_LIBRARY_LISTS_FOR_EDIT';
export type FETCH_LIBRARY_LISTS_FOR_EDIT = typeof FETCH_LIBRARY_LISTS_FOR_EDIT;

export interface FetchLibraryListsForEditAction {
    type: FETCH_LIBRARY_LISTS_FOR_EDIT;
    editorId: string;
    addedLibraryList?: string;
}

export function fetchLibraryListsForEdit(editorId: string, addedLibraryList?: string): FetchLibraryListsForEditAction {
    return {
        type: FETCH_LIBRARY_LISTS_FOR_EDIT,
        editorId,
        addedLibraryList
    };
}

export const SHOW_ERROR_LIBRARY_LIST_EDITOR = 'SHOW_ERROR_LIBRARY_LIST_EDITOR';
export type SHOW_ERROR_LIBRARY_LIST_EDITOR = typeof SHOW_ERROR_LIBRARY_LIST_EDITOR;

export interface ShowErrorLibraryListEditorAction {
    type: SHOW_ERROR_LIBRARY_LIST_EDITOR;
    editorId: string;
    errors: ValidationErrorData[];
}

export function showErrorLibraryListEditor(
    editorId: string,
    errors: ValidationErrorData[]
): ShowErrorLibraryListEditorAction {
    return {
        type: SHOW_ERROR_LIBRARY_LIST_EDITOR,
        editorId,
        errors
    };
}

export const SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS = 'SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS';
export type SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS = typeof SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS;

export interface ShowEditPageMinusPhrasesEditorErrors {
    type: SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS;
    editorId: string;
    minusKeywordsErrors: ValidationErrorData[];
    libraryMinusKeywordsIdsErrors: ValidationErrorData[];
}

export function showEditPageMinusPhrasesEditorErrors(
    editorId: string,
    minusKeywordsErrors: ValidationErrorData[],
    libraryMinusKeywordsIdsErrors: ValidationErrorData[]
): ShowEditPageMinusPhrasesEditorErrors {
    return {
        type: SHOW_EDIT_PAGE_MINUS_PHRASES_EDITOR_ERRORS,
        editorId,
        minusKeywordsErrors,
        libraryMinusKeywordsIdsErrors
    };
}

export const UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION = 'UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION';
export type UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION = typeof UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION;

export interface UpdateMinusPhraseEditorByMassAction {
    type: UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION;
    editorIds: string[];
    minusPhrases: string[];
    selectedLibraryList?: string[];
    libraryItems?: MinusPhrasesLibraryItem[];
    isDelete?: boolean;
}

export function updateMinusPhraseEditorByMassAction(
    editorIds: string[],
    minusPhrases: string[],
    selectedLibraryList?: string[],
    libraryItems?: MinusPhrasesLibraryItem[],
    isDelete?: boolean
): UpdateMinusPhraseEditorByMassAction {
    return {
        type: UPDATE_MINUS_PHRASE_EDITOR_BY_MASS_ACTION,
        editorIds,
        minusPhrases,
        selectedLibraryList,
        libraryItems,
        isDelete
    };
}

export const GET_LIBRARY_LISTS = 'GET_LIBRARY_LISTS';
export type GET_LIBRARY_LISTS = typeof GET_LIBRARY_LISTS;

export interface GetLibraryListsAction {
    type: GET_LIBRARY_LISTS;
    editorId: string;
    data: MinusPhrasesLibraryItem[];
}

export function getLibraryLists(editorId: string, data: MinusPhrasesLibraryItem[]): GetLibraryListsAction {
    return {
        type: GET_LIBRARY_LISTS,
        editorId,
        data
    };
}

export const GET_LIBRARY_LISTS_ERROR = 'GET_LIBRARY_LISTS_ERROR';
export type GET_LIBRARY_LISTS_ERROR = typeof GET_LIBRARY_LISTS_ERROR;

export interface GetLibraryListsErrorAction {
    type: GET_LIBRARY_LISTS_ERROR;
    editorId: string;
}

export function showGetLibraryListsError(editorId: string): GetLibraryListsErrorAction {
    return {
        type: GET_LIBRARY_LISTS_ERROR,
        editorId
    };
}

export const SET_ADDED_LIBRARY_LIST = 'SET_ADDED_LIBRARY_LIST';
export type SET_ADDED_LIBRARY_LIST = typeof SET_ADDED_LIBRARY_LIST;

export interface SetAddedLibraryListAction {
    type: SET_ADDED_LIBRARY_LIST;
    editorId: string;
    addedLibraryList: string;
    maxLength: number;
}

export function setAddedLibraryList(
    editorId: string,
    addedLibraryList: string,
    maxLength: number
): SetAddedLibraryListAction {
    return {
        type: SET_ADDED_LIBRARY_LIST,
        editorId,
        addedLibraryList,
        maxLength
    };
}

export const MINUS_PHRASES_EDITOR_TAB_SELECT = 'MINUS_PHRASES_EDITOR_TAB_SELECT';
export type MINUS_PHRASES_EDITOR_TAB_SELECT = typeof MINUS_PHRASES_EDITOR_TAB_SELECT;

export interface MinusPhrasesEditorTabSelectAction {
    type: MINUS_PHRASES_EDITOR_TAB_SELECT;
    editorId: string;
    tabIndex: MinusPhrasesEditorTabs;
}

export function minusPhrasesEditorTabSelect(
    editorId: string,
    tabIndex: MinusPhrasesEditorTabs
): MinusPhrasesEditorTabSelectAction {
    return {
        type: MINUS_PHRASES_EDITOR_TAB_SELECT,
        editorId,
        tabIndex
    };
}

export const MINUS_PHRASES_EDITOR_CHANGE_VIEW = 'MINUS_PHRASES_EDITOR_CHANGE_VIEW';
export type MINUS_PHRASES_EDITOR_CHANGE_VIEW = typeof MINUS_PHRASES_EDITOR_CHANGE_VIEW;

export interface MinusPhrasesEditorChangeViewAction {
    type: MINUS_PHRASES_EDITOR_CHANGE_VIEW;
    editorId: string;
    view: KeywordsEditorBodyView;
}

export function minusPhrasesEditorChangeView(
    editorId: string,
    view: KeywordsEditorBodyView
): MinusPhrasesEditorChangeViewAction {
    return {
        type: MINUS_PHRASES_EDITOR_CHANGE_VIEW,
        editorId,
        view
    };
}

export type MinusPhrasesActions =
    | OpenMinusPhrasesEditor
    | CloseMinusPhrasesEditor
    | OpenModalEditAddLibraryListAction
    | ChangeMinusPhrasesEditor
    | ClearErrorsMinusPhrasesEditor
    | ToggleEditLibraryListAction
    | CloseModalAddLibraryListAction
    | ChangeLibraryListEditorDataAction
    | AcceptLibraryListEditorDataAction
    | FetchLibraryListsForEditAction
    | UpdateMinusPhraseEditorByMassAction
    | ShowErrorLibraryListEditorAction
    | ShowEditPageMinusPhrasesEditorErrors
    | GetLibraryListsAction
    | GetLibraryListsErrorAction
    | SetAddedLibraryListAction
    | MinusPhrasesEditorTabSelectAction
    | MinusPhrasesEditorChangeViewAction;
